import React from 'react';
import { Box } from '@mui/material';
import Icon from '../base/icons/components/Icon';
import { IconRaiseHandFill } from '../base/icons/svg';
export * from './constants.any';
export const RaisedHandIcon = (React.createElement(Box, { sx: { marginRight: '0px !important' } },
    React.createElement(Icon, { className: 'jitsi-icon-pink', size: 16, src: IconRaiseHandFill })));
